import { haptics } from '../lib/platform';
import { currentRoute, hrefFor, navigate, type Tab } from '../lib/router';
import { Icon, type IconName } from '../ui/Icon';
import s from './TabBar.module.css';

const TABS: { tab: Tab; label: string; icon: IconName; active: IconName; path: string }[] = [
  {
    tab: 'trips',
    label: 'Trips',
    icon: 'suitcase-rolling',
    active: 'suitcase-rolling-fill',
    path: '/',
  },
  {
    tab: 'flights',
    label: 'Flights',
    icon: 'airplane-tilt',
    active: 'airplane-tilt-fill',
    path: '/flights',
  },
  {
    tab: 'wallet',
    label: 'Wallet',
    icon: 'wallet',
    active: 'wallet-fill',
    path: '/wallet',
  },
  { tab: 'news', label: 'News', icon: 'newspaper', active: 'newspaper-fill', path: '/news' },
  { tab: 'stats', label: 'Stats', icon: 'chart-bar', active: 'chart-bar-fill', path: '/stats' },
];

export function TabBar({ active }: { active: Tab }) {
  return (
    <nav className={s.bar} aria-label="Main">
      {TABS.map((t) => {
        const on = t.tab === active;
        return (
          <a
            key={t.tab}
            href={hrefFor(t.path)}
            className={s.tab}
            aria-current={on ? 'page' : undefined}
            onClick={(e) => {
              e.preventDefault();
              void haptics.tick();
              if (on && currentRoute().path === t.path)
                window.scrollTo({ top: 0, behavior: 'smooth' });
              else navigate(t.path, { replace: true, transition: 'fade' });
            }}
          >
            <Icon name={on ? t.active : t.icon} size={24} />
            <span className={s.label}>{t.label}</span>
          </a>
        );
      })}
    </nav>
  );
}
